module.exports = __webpack_public_path__ + "static/media/may_london.c1090ad3.gif";